'use strict';

function InputMoney($filter) {
    'ngInject';
    return {
        require: 'ngModel',
        link: function(scope, elem, attr, ctrl) {
            ctrl.$parsers.unshift(
                function(viewValue){
                    let n = Math.trunc(parseFloat(viewValue) * 100);
                    return n;
                }
            );
            ctrl.$formatters.unshift(
                function(modelValue){
                    let strValue = modelValue.toString();
                    if (strValue == '0') {
                        strValue = '00';
                    }
                    let intPart = strValue.toString().slice(0, -2);
                    if (!intPart) {
                        intPart = '0';
                    }
                    let decPart = strValue.slice(-2);
                    let formatted = `${intPart}.${decPart}`;
                    //console.debug(modelValue, formatted, intPart, decPart);
                    return formatted;
                }
            );
        }
    };
}

export default InputMoney;
